<script>
import { eventBus } from "../../main";

import Swal from "sweetalert2";
import _ from "lodash";

export default {
  props: {
    fileTypes: {
      type: Array,
      default: () => [],
    },
    pathPost: {
      type: String,
      required: true,
    },
    pathPut: {
      type: String,
      required: false,
    },
    autoIncrement: {
      type: Boolean,
      default: () => true,
    },
  },
  data() {
    return {
      progreso: 0,
      tipo: '',
      file: null,
      name: null,
      imageUrl: null,
      typeFile: null,
      loader: false,
      isHovered: false,
      urlDir: "",
      injectData: {},
      guardando: false,
    };
  },
  beforeDestroy() {
    eventBus.$off("GuardandoContenidoCurso");
  },
  async mounted() {
    eventBus.$on("GuardandoContenidoCurso", async (ack, url, jsonData, ticketId) => {
      console.log("Guardando data");
      this.urlDir = url
      this.injectData = jsonData
      try {
        let resultado = await this.onUploadChunks(ticketId);
        ack.resolve(resultado); // <- notifica que terminó exitosamente
      } catch (error) {
        ack.reject(error); // <- notifica error
      }
    });
  },
  computed: {


    backgroundStyle() {
      if (this.imageUrl) {
        return {
          backgroundImage: `url("${this.imageUrl}")`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          position: "relative",
        };
      }
      return {};
    },
    isFile() {
      return this.file ? true : false;
    },
    fileBackground() {
      if (this.file) {
        let backgroundImage = this.imageUrl ? `url("${this.imageUrl}")` : "";
        return {
          backgroundImage: backgroundImage,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        };
      }
      return {};
    },
    extensionOfFileTypes() {
      return this.fileTypes.map((elment) => {
        return elment.substring(elment.lastIndexOf("/") + 1);
      });
    },
  },
  methods: {
    async guardarData(data) {
      const dataSend = { ContenidoClasesCursosAcademia: data };
      console.log("guardarData", data);

      const path = this.injectData.ID !== undefined
        ? this.pathPut + this.injectData.ID
        : this.pathPost;

      return this.$store.getters
        .fetchPost({ path, data: dataSend })
        .then((response) => {
          this.$isLoading(false);
          if (!response.ok) throw new Error("Error en el backend o DB");
          return response.json();
        })
        .then((result) => {
          console.log("dataSend result", result);
          this.$emit("onUploadTicket", result.respuesta, result.mensaje);
          this.restaurar();
          return result;
        })
        .catch((error) => {
          this.$isLoading(false);
          throw error;
        });
    },

    async obtenerTipoDeArchivo() {

      let respuesta = ""
      switch (this.tipo) {
        case 'pdf':
        case 'docx':
        case 'msword':
        case 'vnd.ms-excel':
        case 'xlsx':
        case 'plain':
        case 'vnd.openxmlformats-officedocument.spreadsheetml.sheet':
          respuesta = "documento"
          break;

        // Imágenes
        case 'jpeg':
        case 'jpg':
        case 'png':
        case 'gif':
          respuesta = "imagen"
          break;

        // PowerPoint (ppt, pptx, pps, ppsx)
        case 'pptx':
        case 'vnd.ms-powerpoint': // .ppt, .pps
        case 'ms-powerpoint':     // fallback
        case 'vnd.openxmlformats-officedocument.presentationml.presentation': // .pptx
        case 'vnd.openxmlformats-officedocument.presentationml.slideshow':    // .ppsx
        case 'vnd.ms-powerpoint.presentation.macroEnabled.12': // .pptm
        case 'vnd.ms-powerpoint.slideshow.macroEnabled.12':    // .ppsm
          respuesta = "documento"
          break;

        // Videos
        case 'mp4':
        case 'x-msvideo':
        case 'x-matroska':
        case 'quicktime':
        case 'x-ms-wmv':
        case 'webm':
        case '3gpp':
        case '3gpp2':
          respuesta = "video"
          break;

        default:
          respuesta = "null"
      }
      return respuesta
    },
    handleMouseOver() {
      this.isHovered = true;
    },
    handleMouseLeave() {

      this.isHovered = false;
    },
    quitarTildesYEspacios(input) {
      let sinTildes = _.deburr(input);
      // let sinEspacios = sinTildes.replace(/\s+/g, "");
      return sinTildes;
    },
    restaurar() {
      this.file = null;
      this.imageUrl = null;
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    handleFileChange(event) {
      const selectedFile = event.target.files[0];
      if (selectedFile) {
        this.validateAndProcessFile(selectedFile);

      }
    },
    handleDrop(event) {
      const selectedFile = event.dataTransfer.files[0];
      if (selectedFile) {
        this.validateAndProcessFile(selectedFile);
      }
    },
    formatTime(seconds) {
      return Math.round(Math.max(seconds, 60) / 60).toString().padStart(2, "0");
      // return Math.round(Math.max(seconds, 60) / 60);

      // return Math.floor(seconds).toString().padStart(2, "0");
    },
    validateAndProcessFile(selectedFile) {
      if (this.fileTypes.includes(selectedFile.type) && selectedFile.name.split(".").length <= 2) {
        this.tipo = selectedFile.name.split(".")[1]
        this.file = selectedFile;
        this.typeFile = this.file.name.substring(
          this.file.name.lastIndexOf(".")
        );
        this.name = this.file.name;


        console.log("selectedFile", selectedFile);
        this.$emit("archivoSeleccionado", selectedFile);
        if (selectedFile.type.startsWith("image/")) {
          this.imageUrl = URL.createObjectURL(selectedFile);
          this.videoDuration = 'noVideo'

        }
        if (selectedFile.type.startsWith("video/")) {
          const videoElement = document.createElement("video");
          videoElement.preload = "metadata";
          videoElement.src = URL.createObjectURL(selectedFile);


          videoElement.onloadedmetadata = () => {
            URL.revokeObjectURL(videoElement.src); // Liberar memoria
            if (videoElement.duration === Infinity) {
              // Forzar que calcule duración cargando hasta el final
              videoElement.currentTime = 1e101;
              videoElement.ontimeupdate = () => {
                videoElement.ontimeupdate = null;
                videoElement.currentTime = 0; // reset
                this.videoDuration = this.formatTime(videoElement.duration);
                console.log("[DropFileContenidoAcademia] si era infity Duración del video:", this.videoDuration);
              };
            } else {
              this.videoDuration = this.formatTime(videoElement.duration);
              console.log("[DropFileContenidoAcademia] Duración del video:", this.videoDuration);
            }


            eventBus.$emit("videoDuration", this.videoDuration); // Emitir evento si es necesario
            // videoElement.onloadedmetadata = () => {
            //   URL.revokeObjectURL(videoElement.src); // Liberar memoria
            //   this.videoDuration = videoElement.duration;
            //   console.log("Duración del video:", this.videoDuration);

            //   eventBus.$emit("videoDuration", this.videoDuration);

          };
        }
        else {
          this.videoDuration = 'noVideo'
          eventBus.$emit("videoDuration", this.videoDuration);
        }
      } else {
        console.error("Tipo de archivo no válido.");

        if (!this.fileTypes.includes(selectedFile.type)) {
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "Tipo de archivo no válido.",
            confirmButtonText: "Aceptar",
          });
        }

        if (selectedFile.name.split(".").length > 2) {
          Swal.fire({
            icon: "error",
            title: "Error!",
            text: "El nombre del archivo no puede contener puntos.",
            confirmButtonText: "Aceptar",
          });
        }

        this.file = null;
        this.imageUrl = null;
      }
      this.$refs.fileInput.value = "";
    },

    async onUpload() {
      console.log("Prueba Carga de Archivo");
      try {
        if (this.file != null) {

          // el usuario va a subir archivo
          let nameFileT = this.$moment.tz(new Date(), 'America/Bogota')
            .format('DDMMYYYYHHmmss') + Math.floor(Math.random() * (1 - 99999 + 1)) + 1;
          this.loader = true;
          //this.$isLoading(true);
          const newPath = this.quitarTildesYEspacios(this.urlDir);
          const lastDirectory = newPath.substring(newPath.lastIndexOf("/") + 1);
          const filename = `${lastDirectory}_${nameFileT}${this.typeFile}`;
          const urlImg = newPath.split("/").join("|");

          /**const fileModel = {
            filename: filename,
            file: this.file,
            url: ".|" + urlImg,
          };**/
          let dataTipo = await this.obtenerTipoDeArchivo()
          //let isSave = await this.$store.dispatch("onDropFile", fileModel);

          const formData = new FormData();
          formData.append("file", this.file);
          formData.append("remoteFilePath", urlImg);
          formData.append("FileName", filename);
          formData.append("fileType", this.file.type);

          let isSave = await this.$store.dispatch("hl_post_file_axios", {
            path: "CargaMultimedia/UploadFile",
            data: formData,
            onProgress: (percent) => {
              this.progreso = percent; // ← actualiza la barra visual
              if (percent === 100) {
                this.guardando = true;
              }
              console.log(`Subiendo archivo: ${percent}%`);
            },
          });

          if (isSave.respuesta) {
            const url = "https://www.helexiumfiles.com/" + newPath + "/" + filename;
            const data = {
              ...this.injectData,
              UrlContenidoCurso: url,
              Tipo: dataTipo
            };
            await this.guardarData(data)
          } else {
            this.$isLoading(false);
            throw new Error(isSave.mensaje || "Error al subir el archivo");
          }
        } else {
          //solamente guardaré la data es decir actualizaré el archivo
          const data = {
            ...this.injectData
          };
          await this.guardarData(data)
        }
      } catch (error) {
        //this.$isLoading(false);

        console.log(error);
        Swal.fire({
          icon: "error",
          title: "Error!",
          text: error.message,
          confirmButtonText: "Aceptar",
        });
      } finally {
        this.loader = false;
        this.guardando = false;
      }
    },
    async onUploadChunks(ticketId) {
      console.log("Prueba Carga de Archivo por chunks");
      try {
        if (!this.file) {
          // Si no hay archivo, solo guardar la data
          await this.guardarData({ ...this.injectData });
          return;
        }

        this.loader = true;

        // Generar nombre final
        //let nameFileT = this.$moment.tz(new Date(), 'America/Bogota')
         // .format('DDMMYYYYHHmmss') + Math.floor(Math.random() * (1 - 99999 + 1)) + 1;
        const newPath = this.quitarTildesYEspacios(this.urlDir);
        //const lastDirectory = newPath.substring(newPath.lastIndexOf("/") + 1);
        const filename = `${ticketId} - ${this.file.name}`;
        const urlImg = newPath.split("/").join("|");


        // Configuración de chunks
        const chunkSize = 5 * 1024 * 1024; // 5MB
        const totalChunks = Math.ceil(this.file.size / chunkSize);
        const uploadId = crypto.randomUUID(); // Identificador único
        let DriveId = "";
        for (let chunkNumber = 1; chunkNumber <= totalChunks; chunkNumber++) {
          const start = (chunkNumber - 1) * chunkSize;
          const end = Math.min(start + chunkSize, this.file.size);
          const chunkBlob = this.file.slice(start, end);

          const formData = new FormData();
          formData.append("chunk", chunkBlob);
          formData.append("chunkNumber", chunkNumber);
          formData.append("totalChunks", totalChunks);
          formData.append("remoteFilePath", urlImg);
          formData.append("uploadId", uploadId);
          formData.append("fileName", filename);
          formData.append("fileType", this.file.type);

          await this.$store.dispatch("hl_post_file_axios", {
            path: "CargaMultimedia/UploadChunkDrive",
            data: formData,
            onProgress: (percent) => {
              const globalPercent = Math.floor(((chunkNumber - 1) / totalChunks) * 100 + percent / totalChunks);
              this.progreso = globalPercent;
              if (globalPercent === 100) this.guardando = true;
              console.log(`Subiendo chunk ${chunkNumber}/${totalChunks}: ${globalPercent}%`);
            },
          }).then(res => {
            if (!res.respuesta) {
              throw new Error(res.mensaje || `Error al subir el chunk ${chunkNumber}`);
            }
            else if (res.respuesta && res.data && res.data.length > 0) {
              DriveId = res.data; // Guardar DriveId si es devuelto
              console.log("Archivo subido correctamente:", res.data);
            }
          });
        }

        // Si todos los chunks se subieron bien
        const url = DriveId;
        await this.guardarData({
          ...this.injectData,
          urlAdjunto: url,
        });
        return DriveId;

      } catch (error) {
        await Swal.fire({
          icon: "error",
          title: "Error!",
          text: error.message,
          confirmButtonText: "Aceptar",
        });
      }
      finally {
        this.loader = false;
        this.guardando = false;
      }
    }

  },
};
</script>

<template>
  <form @submit.prevent="onUpload">
    <div v-if="progreso > 0 && progreso < 100" style="width: 100%; padding: 0 1rem; margin-top: 1rem;">
      <progress :value="progreso" max="100" style="width: 100%"></progress>
      <div class="text-center text-white mt-1">{{ progreso }}%</div>
    </div>
    <div v-if="guardando" class="text-center mt-2" style="width: 100%; padding: 0 1rem; margin-top: 1rem;">
      Guardando contenido...
    </div>
    <slot name="header"> </slot>
    <input type="file" @change="handleFileChange" ref="fileInput" style="display: none" />
    <div class="dropzone" :class="{ 'is-file': isFile }" :style="fileBackground" @click="triggerFileInput"
      @drop.prevent="handleDrop" @dragover.prevent @dragenter.prevent @mouseover="handleMouseOver"
      @mouseleave="handleMouseLeave">
      <div v-if="loader" class="loader"></div>
      <div class="overlay" v-if="imageUrl"></div>
      <div v-if="!file" class="d-flex flex-column align-items-center">
        <i :class="['fas fa-cloud-arrow-up text-white-50', isHovered && 'fa-beat']" style="font-size: 2rem"></i>
        <br />
        Haz clic o arrastra un archivo aquí.
      </div>
      <div v-else class="d-flex flex-column align-items-center" style="z-index: 3">
        <i :class="`fas fa-file-circle-check ${loader && 'fa-bounce'}`" style="font-size: 2rem"></i>
        <br />
        <span>
          El documento "
          <span class="text-primary font-weight-bold">{{ name }}</span> " ha
          sido cargado
        </span>
      </div>
    </div>
    <slot name="prevFooter"> </slot>
  </form>
</template>

<style scoped>
form {
  width: 100%;
  min-height: 200px;
  height: 100%;
  display: flex;
  flex-direction: column;
}

.dropzone {
  width: 100%;
  min-height: 150px;
  height: 80%;
  border: 2px dashed #ccc;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  position: relative;
  transition: 0.3s all;

  &:hover {
    background-color: #ececec;
  }

  .dark &:hover {
    background-color: #131416;
  }
}

.is-file {
  background-color: #ececec;

  .dark & {
    background-color: #131416;
  }
}

.loader {
  width: 100%;
  height: 100%;
  position: absolute;

  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
}

.overlay {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.8);
  z-index: 2;
}

.actions {
  width: 100%;
  height: 20%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
}

.list-enter-active,
.list-leave-active {
  transition: all 0.5s ease;
}

.list-enter-from,
.list-leave-to {
  opacity: 0;
  transform: translateX(30px);
}
</style>
